import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 21.932L2.2 11.84a5.667 5.667 0 0 1-1.087-6.607A5.839 5.839 0 0 1 10.4 3.746L12 5.205l1.6-1.459a5.84 5.84 0 0 1 9.287 1.487A5.669 5.669 0 0 1 21.8 11.84z",
  fill: "none"
});

var SvgLoveIt = function SvgLoveIt() {
  return _ref;
};

export default SvgLoveIt;